import { render, staticRenderFns } from "./excel_procesa_matriculas.vue?vue&type=template&id=7886bc44"
import script from "./excel_procesa_matriculas.vue?vue&type=script&lang=js"
export * from "./excel_procesa_matriculas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports